
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface CartButtonProps {
  cartCount: number;
}

const CartButton = ({ cartCount }: CartButtonProps) => {
  const navigate = useNavigate();

  return (
    <div className="relative">
      <button 
        className="rounded-full p-2 transition duration-200 hover:bg-kbeauty-cream"
        onClick={() => navigate('/cart')}
        aria-label={`View shopping cart${cartCount > 0 ? ` (${cartCount} items)` : ''}`}
      >
        <ShoppingCart className="h-5 w-5" />
        {cartCount > 0 && (
          <Badge 
            className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 bg-kbeauty-brown text-white text-xs"
          >
            {cartCount}
          </Badge>
        )}
      </button>
    </div>
  );
};

export default CartButton;
